$(function () {

	//アコーディオン
	$(".acd_content").hide();
	$(".acd_visual").on("click", function() {
		if($(this).hasClass('open')){
			$(this).removeClass("open");
			// $(this).find(".acd_content").slideUp();
			$(this).find(".acd_visual_btn_text").html("MORE");
			$(this).next().slideUp();
		} else {
			$(this).addClass("open");
			// $(this).find(".acd_content").slideDown();
			$(this).find(".acd_visual_btn_text").html("CLOSE");
			$(this).next().slideDown(
				function(){
					var position = $(this).offset().top;
					// console.log(position);
					if (window.matchMedia( "(max-width: 768px)" ).matches) {
						/* ウィンドウサイズが 768px以下の場合 */
						$("html,body").animate({
							scrollTop : position - 230 //スクロール位置調整
						});
					} else {
						/* ウィンドウサイズが 768px以上の場合 */
						$("html,body").animate({
							scrollTop : position - 330 //スクロール位置調整
						});
					}
				}
			);
		}
	});

	//閉じるボタンがクリックされたら
	$(".btn_close").click(function () {
		$(".acd_visual").removeClass("open");
		$(".acd_visual_btn_text").html("MORE");
		$(this).parents(".acd_content").slideUp(
			function(){
				var position02 = $(this).parents(".acd_menu").offset().top;
				console.log(position02);
				if (window.matchMedia( "(max-width: 768px)" ).matches) {
					/* ウィンドウサイズが 768px以下の場合 */
					$("html,body").animate({
						scrollTop : position02 - 70 //スクロール位置調整
					});
				} else {
					/* ウィンドウサイズが 768px以上の場合 */
					$("html,body").animate({
						scrollTop : position02 - 90 //スクロール位置調整
					});
				}
			}
		);
	});

});